import { render, staticRenderFns } from "./BaseMitLandingPage.vue?vue&type=template&id=9b103788&scoped=true"
import script from "./BaseMitLandingPage.vue?vue&type=script&lang=js"
export * from "./BaseMitLandingPage.vue?vue&type=script&lang=js"
import style0 from "./BaseMitLandingPage.vue?vue&type=style&index=0&id=9b103788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b103788",
  null
  
)

export default component.exports